export default "__VITE_ASSET__613ae757__"